export function removeFalsyValues(input: object): object {
  return Object.entries(input).reduce(
    (acc, [key, value]) => (value ? ((acc[key] = value), acc) : acc),
    {}
  );
}

export function isEmpty(object: {}): boolean {
  if (!object) {
    return true;
  }
  return Object.keys(object)?.length === 0;
}

export function isDefined(object: any): boolean {
  return object !== undefined && object !== null;
}
